// extracted by mini-css-extract-plugin
export var logo = "_lm-2";
export var logoWrapper = "_lm-1";
export var strip = "_lm-0";